export default __webpack_public_path__ + "83ebdc9f5008e623f9deea2a407a931f.woff";